import React from 'react';
import Tooltip from './Tooltip';

/**
 * Truncates long text and shows a tooltip with the full value on hover/focus.
 */
function TruncatedText({ children, className = '', as: Component = 'span', tooltip = true }) {
  const text = children == null ? '' : String(children);
  if (!text) return null;

  const node = (
    <Component
      className={`block min-w-0 truncate ${className}`.trim()}
      tabIndex={tooltip ? 0 : undefined}
    >
      {text}
    </Component>
  );

  if (!tooltip) return node;

  return (
    <Tooltip content={text} position="top" className="min-w-0 max-w-full">
      {node}
    </Tooltip>
  );
}

export default TruncatedText;
